import { createTheme, ThemeOptions } from '@mui/material/styles';

import * as colors from '../colors';
import { Theme } from '../types';

import { baseTheme } from './base-theme';

const lightThemeOptions: ThemeOptions = {
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: colors.primary,
    secondary: colors.secondary,
    error: colors.error,
    warning: colors.warning,
    info: colors.info,
    success: colors.success,
    background: {
      default: colors.background.default,
      paper: colors.background.paper,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
      disabled: colors.text.disabled,
    },
    divider: colors.divider,
    grey: colors.grey,
    common: colors.common,
  },
  components: {
    ...baseTheme.components,
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.primary.main,
          color: colors.common.white,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: colors.background.paper,
          borderRight: `1px solid ${colors.divider}`,
        },
      },
    },
  },
};

export const lightTheme = createTheme(lightThemeOptions) as Theme;
